var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    viewBox: "0 96 960 960",
    width: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#daa520",
    d: "M180 936q-24 0-42-18t-18-42V306q0-24 18-42t42-18h600q24 0 42 18t18 42v570q0 24-18 42t-42 18H180Zm300-420q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM180 810q54-54 122-82.5T480 699q66 0 134 28.5T736 810V306H180v504Zm300-234q-30 0-57.5 10.5T373 607q-23 18-37 46t-14 62v30h300v-30q0-34-14-62t-37-46q-23-18-50.5-28.5T480 576Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBox);
export default __webpack_public_path__ + "static/media/account-box.1a81b66165c34d5d79aef65ec798d24e.svg";
export { ForwardRef as ReactComponent };